
export default {
    getStatusCurso(state) {
        return state.statusCurso
    },
    getStatusCursos(state) {
        return state.statusCursos
    },
}